<template>
  <el-dialog width="1400px" title="Select Bank Account" :close-on-click-modal="false" :visible.sync="visible" top="3vh">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" autocomplete="off" label-position="top">
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item prop="bankAccountIds">
            <select-bank-account v-model="dataForm.bankAccountIds" :supplierBankAccountList="invoiceTemplateBankAccountList" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">Cancel</el-button>
      <el-button type="primary" @click="dataFormSubmit">OK</el-button>
    </span>
  </el-dialog>
</template>

<script>
import SelectBankAccount from "@/components/SelectBankAccount";
export default {
  components: {
    SelectBankAccount,
  },
  data() {
    return {
      visible: false,
      dataForm: {
        bankAccountIds: [],
      },
      dataRule: {
        bankAccountIds: [{ type: "array", required: true, message: "please select", trigger: "submit" }],
      },
      invoiceTemplateBankAccountList: [], // 发票模板下的银行账户列表
      indexVal: null, // 索引
    };
  },

  methods: {
    async init(selectedBankAccountIds, invoiceTemplateBankAccountList, index) {
      this.visible = true;
      await this.$nextTick();
      this.$refs["dataForm"].resetFields();
      const selectedBankAccountIdsCopy = JSON.parse(JSON.stringify(selectedBankAccountIds));
      this.dataForm = {
        bankAccountIds: selectedBankAccountIdsCopy || [],
      };
      this.invoiceTemplateBankAccountList = invoiceTemplateBankAccountList || [];
      this.indexVal = index;
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs["dataForm"].validate(valid => {
        if (valid) {
          const params = {
            ...this.dataForm,
          };
          this.$emit("updateBankAccountIds", params.bankAccountIds, this.indexVal);
          this.visible = false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.addBtnWrap {
  text-align: right;
  margin-top: -32px;
}

.itemListWrap {
  margin-top: 8px;
  padding: 0px 10px;
  background: #f5f7fa;
  border-radius: 2px;

  .itemTitle {
    font-size: 13px;
    text-align: center;
  }
}
</style>
